const websiteUrl = "https://thestratos.org";

const pageURL = {
  webSite: websiteUrl,
  home: "/",
  landing: "/home",
  pageSlug: "/page/:slug",
  postSlug: "/post/:slug",
  directPostSlug: "/:slug",
  postDateSlug: "/:year/:month/:day/:slug",
  categoryId: "/category/:catid",
  searchTerm: "/search/:term",
  networkDecFoundation: `${websiteUrl}/network/dec-foundation`,
  networkDevTools: `${websiteUrl}/network/dev-tools`,
  ecosystem: `${websiteUrl}/ecosystem`,
  comingSoon: `${websiteUrl}/coming-soon`,
  wallet: `${websiteUrl}/stratos-network-wallet`,
  ecosystemProject: `${websiteUrl}/ecosystem/:projectId`,
  useCaseGameFi: `${websiteUrl}/use-case/game-fi`,
  useCaseEnterpriseData: `${websiteUrl}/use-case/enterprise-data`,
  useCaseCdnAcceleration: `${websiteUrl}/use-case/cdn-acceleration`,
  useCaseVideoSreaming: `${websiteUrl}/use-case/video-streaming`,
  useCaseDapp: `${websiteUrl}/use-case/dapp`,
  communityCollaborate: `${websiteUrl}/community/collaborate`,
  communityBounty: `${websiteUrl}/community/bounty`,
  communityStaking: `${websiteUrl}/community/staking`,
  communityInvestors: `${websiteUrl}/community/investors`,
  communityPartner: `${websiteUrl}/community/partner`,
  resourcesGuide: `${websiteUrl}/resources/guide`,
  resourcesFaq: `${websiteUrl}/resources/faq`,
  contactUs: `${websiteUrl}/contact-us`,
  resourcesPrivacyPolicy: `${websiteUrl}/resources/privacy-policy`,
};

export default pageURL;
